import {http} from "..";

export const getVerificationProviderInformation = async () =>
  http.get(`/agent/verification-provider/info`);
